module.exports = __webpack_public_path__ + "static/img/pic3.884be10.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/recordInformation/pic3.png
// module id = 1688
// module chunks = 2